const HOME_URL = {
  arena_tw: 'https://tw.nexon.com/main/zh',
  arena_th: 'https://th.nexon.com/main/th',
  arena_west: 'https://www.nexon.com/main/en',
  arena_sea: '', //링크 없음 임
  krpc: 'https://www.nexon.com/',
  jppc: 'https://jp.nexon.com/',
  default: 'https://www.nexon.com/main/en',
};

const FAQ_URL = {
  krpc: {
    ko: 'https://guide.nexon.com/ko/game/rp/guides/rewardpoint/',
    en: 'https://guide.nexon.com/en/game/rp/guides/rewardpoint',
    zh: 'https://guide.nexon.com/zh_tw/game/rp/guides/rewardpoint/',
    ja: 'https://guide.nexon.com/ja/game/rp/guides/rewardpoint/',
  },
  arena: {
    ko: 'https://guide.nexon.com/ko/game/rp/guides/global/',
    en: 'https://guide.nexon.com/en/game/rp/guides/global/',
    zh: 'https://guide.nexon.com/zh_tw/game/rp/guides/global/',
    ja: 'https://guide.nexon.com/ja/game/rp/guides/global/',
  },
  jppc: {
    ko: 'https://guide.nexon.com/ko/game/rp/guides/jp/pages/602',
    en: 'https://guide.nexon.com/en/game/rp/guides/jp/pages/602',
    zh: 'https://guide.nexon.com/zh_tw/game/rp/guides/jp/pages/602',
    ja: 'https://guide.nexon.com/ja/game/rp/guides/jp/pages/602',
  },
};

const GLOBAL_GUIDE_URL = {
  en: 'https://guide.nexon.com/en/game/rp/guides/global/pages/201',
  zh: 'https://guide.nexon.com/zh_tw/game/rp/guides/global/pages/201',
  ko: 'https://guide.nexon.com/ko/game/rp/guides/global/pages/201',
  ja: 'https://guide.nexon.com/ja/game/rp/guides/jp/pages/501',
};

const NJ_OTP_URL = `${process.env.VUE_APP_NJ_PORTAL}/mypage/security`;

const NJ_FORM_DATA = {
  APPLY_TYPE: ['個人口座（本人名義）', '個人口座（保護者名義）', '法人口座'],
  PREFECTURE: [
    '北海道',
    '青森県',
    '岩手県',
    '宮城県',
    '秋田県',
    '山形県',
    '福島県',
    '茨城県',
    '栃木県',
    '群馬県',
    '埼玉県',
    '千葉県',
    '東京都',
    '神奈川県',
    '新潟県',
    '富山県',
    '石川県',
    '福井県',
    '山梨県',
    '長野県',
    '岐阜県',
    '静岡県',
    '愛知県',
    '三重県',
    '滋賀県',
    '京都府',
    '大阪府',
    '兵庫県',
    '奈良県',
    '和歌山県',
    '鳥取県',
    '島根県',
    '岡山県',
    '広島県',
    '山口県',
    '徳島県',
    '香川県',
    '愛媛県',
    '高知県',
    '福岡県',
    '佐賀県',
    '長崎県',
    '熊本県',
    '大分県',
    '宮崎県',
    '鹿児島県',
    '沖縄県',
  ],
};

const NJ_AUTH_STATUS = {
  IN_PROGRESS: '検討中',
  SUCCESS: '承認済',
  FAILED: '差戻し',
  REQUEST_TO_RETRY: '更新必要',
};

const API_RETURN_CODE = Object.freeze({
  NO_ERROR: 0,
  UNKNOWN_ERROR: -1,
  MAINTAINNANCE: 1,
  NOT_LOGIN: 2,
  NON_LANGUAGE_DATA: 7001,
});

const API_RETURN_CODE_USERINFO = Object.freeze({
  NO_USERINFO: 6001,
  NO_BUSINESSINFO: 6002,
  IN_PROCESS_BUSINESSINFO: 6003,
  NO_COMPLETE_INFO: 6004,
});

export {
  API_RETURN_CODE,
  API_RETURN_CODE_USERINFO,
  HOME_URL,
  FAQ_URL,
  GLOBAL_GUIDE_URL,
  NJ_OTP_URL,
  NJ_FORM_DATA,
  NJ_AUTH_STATUS,
};
